/*
  Ponto de entrada da aplicação Vue.
  Responsável por criar a instância do app, aplicar plugins (Pinia, Router, i18n, WaveUI, etc.),
  importar estilos globais e montar o app na DOM.
*/

// Bibliotecas principais do Vue
import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Frameworks e plugins de UI/UX
import WaveUI from 'wave-ui'
import VueAwesomePaginate from 'vue-awesome-paginate'

// Importação de estilos globais e de plugins
import 'wave-ui/dist/wave-ui.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-awesome-paginate/dist/style.css'
import '@yaireo/tagify/dist/tagify.css'
import './assets/styles.css'

// Bootstrap JS (necessário para dropdowns, collapse, etc)
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

// Componentes e módulos locais
import App from './App.vue'
import router from './router'
import i18n from './i18n/i18n.js'

// Criação da instância do app e do Pinia
const app = createApp(App)
const pinia = createPinia()

// Propriedade global para o domínio da API
// app.config.globalProperties.$dominio = 'http://caed.icmc.usp.br:8081'
// app.config.globalProperties.$dominio = 'http://localhost:8081'
app.config.globalProperties.$dominio = 'https://aquarelaapi.dev.br'

// Hook do router para GA4
router.afterEach((to, from) => {
  // garante que gtag existe
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: to.meta.title || document.title,
      page_path: to.fullPath,
      page_location: window.location.href
    });
  }
});

// Registro dos plugins na aplicação
app.use(VueAwesomePaginate)
app.use(router)
app.use(pinia)
app.use(WaveUI)
app.use(i18n)

// Monta o app na div #app
app.mount('#app')